import { Sparkles, ShieldCheck, Bot, Target, Wand2, CheckCircle2 } from "lucide-react";

// Phase 2Z.w-5 - In-React product collage for the homepage hero.
// Uses realistic, generic demo wording only. No fake customer names,
// no fake operational numbers, no fabricated screenshots. Every tile
// reflects something the product actually does today.
export default function HeroCollage() {
  return (
    <div className="relative" data-testid="hero-collage">
      {/* Rota tile */}
      <div className="rounded-xl border border-slate-200 bg-white shadow-sm p-4"
        data-testid="hero-collage-rota">
        <div className="flex items-center justify-between mb-2">
          <div className="text-[10px] uppercase tracking-widest text-[#94A3B8] font-semibold">Weekly rota</div>
          <Wand2 className="h-3.5 w-3.5 text-[#1D4ED8]"/>
        </div>
        <div className="grid grid-cols-5 gap-1">
          {Array.from({length: 20}).map((_, i) => (
            <div key={i}
              className={`h-5 rounded ${
                i % 7 === 3 ? "bg-amber-200"
                : i % 5 === 0 ? "bg-emerald-200"
                : "bg-[#DBE7FE]"}`}/>
          ))}
        </div>
      </div>

      {/* Coverage Guard tile, overlapping */}
      <div className="absolute -right-3 top-12 rounded-xl border border-amber-200 bg-amber-50 shadow-sm p-3 w-44"
        data-testid="hero-collage-coverage">
        <div className="flex items-center gap-1.5 mb-1">
          <ShieldCheck className="h-3.5 w-3.5 text-amber-700"/>
          <div className="text-[10px] uppercase tracking-widest text-amber-800 font-semibold">Coverage Guard</div>
        </div>
        <div className="text-[11px] text-amber-900">Helpdesk dips below minimum on Wed.</div>
        <div className="text-[10px] text-amber-800 mt-1">Preview before applying</div>
      </div>

      {/* RMI Assistant tile */}
      <div className="mt-4 rounded-xl border border-slate-200 bg-white shadow-sm p-3"
        data-testid="hero-collage-rmi">
        <div className="flex items-center gap-1.5 mb-1">
          <Bot className="h-3.5 w-3.5 text-[#1D4ED8]"/>
          <div className="text-[10px] uppercase tracking-widest text-[#94A3B8] font-semibold">RMI Assistant</div>
        </div>
        <div className="text-[12px] text-[#0F1B3D] italic">"Increase Customer Support on Mondays"</div>
        <div className="text-[10px] text-[#4B5773] mt-1.5">Suggested: +10% from Outbound. Preview before applying.</div>
      </div>

      {/* Performance Focus + Autopilot row */}
      <div className="mt-4 grid grid-cols-2 gap-3">
        <div className="rounded-xl border border-slate-200 bg-white shadow-sm p-3"
          data-testid="hero-collage-performance">
          <div className="flex items-center gap-1.5 mb-1">
            <Target className="h-3.5 w-3.5 text-emerald-700"/>
            <div className="text-[10px] uppercase tracking-widest text-[#94A3B8] font-semibold">Performance</div>
          </div>
          <div className="flex items-center justify-between">
            <div className="text-xl font-semibold text-[#0F1B3D]">87%</div>
            <span className="text-[10px] text-emerald-700">+4 vs last</span>
          </div>
          <div className="flex gap-1 mt-1">
            <span className="text-[10px] text-emerald-700">● 3</span>
            <span className="text-[10px] text-amber-600">● 1</span>
            <span className="text-[10px] text-rose-600">● 0</span>
          </div>
        </div>
        <div className="rounded-xl border border-[#0B1A36] bg-[#0B1A36] text-white shadow-sm p-3"
          data-testid="hero-collage-autopilot">
          <div className="flex items-center gap-1.5 mb-1">
            <Sparkles className="h-3.5 w-3.5 text-emerald-300"/>
            <div className="text-[10px] uppercase tracking-widest text-white/70 font-semibold">Autopilot</div>
          </div>
          <div className="flex items-center gap-1.5 text-[12px] mt-1">
            <CheckCircle2 className="h-3 w-3 text-emerald-300"/> Draft prepared
          </div>
          <div className="flex items-center gap-1.5 text-[12px] mt-1">
            <CheckCircle2 className="h-3 w-3 text-emerald-300"/> Approved on schedule
          </div>
          <div className="text-[10px] text-white/60 mt-1.5">Manager-controlled, rules-based.</div>
        </div>
      </div>
    </div>
  );
}
